import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {ActionButton} from '../components/ActionButton';
import MenuItemIcon from '../components/MenuItemIcon';
import DivContainer from '../components/DivContainer';
import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
import AuthService from '../services/AuthService';
import {ActionLink} from '../components/ActionLink';

class OrderCardConfirmationDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.user = new AuthService().getProfile();
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    render() {
        const {className, id, key, name, onHide, visible, style} = this.props;
        return (
            <Dialog
                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                header={this.renderHeader()}
                visible={visible}
                className={className}
                style={style}
                key={`${key ? key : id ? id : name}-dialog`}
                onHide={() => (onHide ? onHide() : null)}
                closable={this.state.closable}
            >
                {this.state.loading ? null : (
                    <Card footer={this.prepareFooter()}>
                        <form onSubmit={this.handleFormSubmit} noValidate>
                            {this.renderDetails()}
                        </form>
                    </Card>
                )}
            </Dialog>
        );
    }
    handleFormSubmit() {}
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.close')} variant='button save-button blue' handleClick={this.props.onHide} />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <MenuItemIcon alt='' className='' iconSvg='ico_green_checkbox' />
                    </DivContainer>
                    <DivContainer colClass='col-12'>
                        <label id={`card-order-confirmation-header-label-id`}>
                            {t(`order-card.confirmationDialog${this.props.draft ? '.draft' : ''}.header`)}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <label className='col-12 font-14-400 order-confirmation-dialog-body-label'>
                        {t(`order-card.confirmationDialog${this.props.draft ? '.draft' : ''}.body`, {
                            email: this.user?.agreementEmail,
                        })}
                        <ActionLink
                            label={t('order-card.orderLink')}
                            href={`${this.props.orderListUrl}?${this.props.draft ? 'draftId' : 'id'}=${this.props.orderResponse.id}`}
                            variant='blue'
                            className='edit-blue-link'
                            key={'view-button'}
                        />
                        .
                    </label>
                </div>
            </React.Fragment>
        );
    }
}

OrderCardConfirmationDialog.defaultProps = {
    visible: false,
    viewMode: 'EDIT',
    orderResponse: '',
    orderListUrl: '/#/card-order-list',
    draft: false,
};

OrderCardConfirmationDialog.propTypes = {
    orderResponse: PropTypes.object,
};

export default withTranslation()(OrderCardConfirmationDialog);
